import useFreePlanStatus from '../../hooks/useFreePlanStatus';
import './FreePlanBadge.css';

/**
 * Badge compacto para exibir no menu/header
 * Mostra "Plano FREE" e dias restantes se aplicável
 */
export default function FreePlanBadge() {
  const freeStatus = useFreePlanStatus();
  
  // Não exibe se não é plano FREE
  if (!freeStatus.isFreePlan) {
    return null;
  }
  
  // Se está expirado, não exibe (o modal já cuidará disso)
  if (freeStatus.isExpired) {
    return null;
  }
  
  // Determinar classe CSS baseada no nível de urgência
  const badgeClass = freeStatus.urgencyLevel === 'danger' 
    ? 'free-badge-danger' 
    : freeStatus.urgencyLevel === 'warning' 
    ? 'free-badge-warning' 
    : 'free-badge-info';
  
  return (
    <div className="free-plan-badge-container">
      <span className="free-badge-plan">Plano FREE</span>
      {freeStatus.daysRemaining !== null && freeStatus.daysRemaining <= 30 && (
        <span className={`free-badge-days ${badgeClass}`}>
          {freeStatus.daysRemaining} {freeStatus.daysRemaining === 1 ? 'dia' : 'dias'}
        </span>
      )}
    </div>
  );
}
